/**
 * Constants for Supplier Performance module
 */

import { SupplierPerformanceFilterValues } from '../../components/suppliers/SupplierPerformanceFilters';
import { getLast12MonthsRange } from '../../components/dashboard/DashboardFilters';

// CR-4782: Default to Last 12 Months (excluding current month) with N/A ratings excluded,
// so users land on a clean, relevant view without having to adjust filters.
const { dateFrom: defaultDateFrom, dateTo: defaultDateTo } = getLast12MonthsRange();

export const DEFAULT_FILTERS: SupplierPerformanceFilterValues = {
  division: 'all',
  site: 'all',
  supplierGroup: 'all',
  supplierSite: 'all',
  supplierCode: '',
  warehouse: 'all',
  strategic: false,
  hideChildCompanies: false,
  commodityGroup: 'all',
  commodityType: 'all',
  timePeriod: 'last12Months',
  dateFrom: defaultDateFrom,
  dateTo: defaultDateTo,
  orderType: [],
  supplierType: 'all',
  rating: 'all',
  excludeNARatings: true,
  dataMode: 'historical',
  // CR-4783: Geographic filters default to 'all'
  siteCountry: 'all',
  supplierCountry: 'all',
};

export const MODAL_PAGE_SIZE = 20;
